import type { UseAnalyticsOptions } from '~/composables/analytics/useAnalytics'
import type { FinancingDetailsExitedEventPayload } from '~/types/analytics'
import { useAnalytics } from '~/composables/analytics/useAnalytics'

export function useTrackFinancingDetailsExited(options: UseAnalyticsOptions = {}) {
  const { trackEvent } = useAnalytics(options)

  function trackFinancingDetailsExited(payload: FinancingDetailsExitedEventPayload) {
    trackEvent('financing_details_exited', { ...payload })
  }

  return { trackFinancingDetailsExited }
}
